import {NgModule} from '@angular/core';
import {DexTrancheUtilityService} from './dex-tranche-utility.service';
import {TrancheDelRefBalanceService} from './tranche-del-ref-balance.service';

@NgModule({
    providers: [
        DexTrancheUtilityService,
        TrancheDelRefBalanceService
    ]
})
export class DexTrancheUtilityModule {}
